// "Push on this browser": what it is now, and Turn on or Turn off. Which categories push is used for is in
// "You hear about" (Notifications); this row is whether this browser gets it at all.
import { PUSH_WORDS, usePush } from '../lib/push';

export function PushRow() {
  const p = usePush();
  const can = p.state === 'off' || p.state === 'on';
  return (
    <div className="col gap6" role="group" aria-label="Push on this browser" data-push={p.state}>
      <div className="rowc gap6" style={{ justifyContent: 'space-between' }}>
        <span className="sm">Push on this browser</span>
        {can && (p.state === 'on'
          ? <button type="button" className="bt sm" disabled={p.busy} onClick={() => void p.turnOff()}>Turn off</button>
          : <button type="button" className="bt sm pri" disabled={p.busy} onClick={() => void p.turnOn()}>{p.busy ? <span className="spin" /> : null}Turn on</button>)}
      </div>
      <div className="xs mut" style={{ lineHeight: 1.5 }}>{PUSH_WORDS[p.state]}</div>
      {p.error && <div className="xs" role="alert" style={{ color: 'var(--red-tx)' }}>{p.error}</div>}
    </div>
  );
}
